// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import topMenu from './components/topMenu.vue'
import searchFilter from './components/filter.vue'
import SETTING from './components/SETTING.vue'
import STATUS from './components/STATUS.vue'
import md5 from 'md5'
import axios from 'axios'

Vue.config.productionTip = false

Vue.component('topMenu', topMenu)
Vue.component('searchFilter', searchFilter)
Vue.component('SETTING', SETTING)
Vue.component('STATUS', STATUS)

//global
const bus = new Vue({
	data: {
		mamServer: "http://71.4.56.4:2001",
		login: false
	}
})

Object.defineProperty(Vue.prototype,"$md5",{value: md5})
Object.defineProperty(Vue.prototype,"axios",{value: axios})
Object.defineProperty(Vue.prototype,"$bus",{value: bus})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js